import {
  ActivityCode,
  activityCodeDescriptionMap,
  AuditEvent,
  EnrichedAuditEvent,
} from '@eppendorf/vnls-audit-event-client';

import { AffectedCell } from '$features/audit-events/components/affected/affected-cell';
import { AffectedReport } from '$features/audit-events/components/affected/affected-report';
import { DeviceEventMetadata } from '$features/audit-events/types';

const deviceEventActivityCodes: ActivityCode[] = [
  ActivityCode.DEVICE_EVENT_ALERT,
  ActivityCode.DEVICE_EVENT_ERROR,
  ActivityCode.DEVICE_EVENT_WARNING,
  ActivityCode.DEVICE_EVENT_INFO,
] as const;

const reportHubActivityCodes: ActivityCode[] = [
  ActivityCode.AUDIT_TRAIL_EXPORT,
  ActivityCode.REPORT_DOWNLOAD,
  ActivityCode.REPORT_DELETED,
] as const;

export function AuditEventDescription({ event }: { event: EnrichedAuditEvent }) {
  const isDeviceEvent = deviceEventActivityCodes.includes(event.activityCode);
  const reportHubEvent = reportHubActivityCodes.includes(event.activityCode);

  if (reportHubEvent) {
    return (
      <AffectedReport
        startDate={event.metadata?.startDate as string}
        endDate={event.metadata?.endDate as string}
      />
    );
  }

  if (!isDeviceEvent) {
    return (
      <AffectedCell
        entities={event?.metadata?.affectedEntities}
        deviceType={event?.metadata?.selectedDeviceType as string}
      />
    );
  }

  return (
    (event as AuditEvent<DeviceEventMetadata>).metadata?.deviceEvent?.message ??
    activityCodeDescriptionMap[event.activityCode]
  );
}
